export const FETCH_SENSORS = 'FETCH_SENSORS';
export const FETCH_SENSOR = 'FETCH_SENSOR';
export const FETCH_COMPONENTS = 'FETCH_COMPONENTS';
export const FETCH_SUBSYSTEM = 'FETCH_SUBSYSTEM';
export const FETCH_LISTSENSORS = 'FETCH_LISTSENSORS';

/* use the state type FETCH_SENSORS FETCH_SENSOR FETCH_COMPONENTS FETCH_SUBSYSTEM FETCH_LISTSENSORS */

